import { Flex } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { SelectCafeteriaForm } from '../components/SelectCafeteriaForm/SelectCafeteriaForm';
import { TopBar } from '@/components';
import { DefaultContainer } from '@/containers/DefaultContainer';
import '@/components/GetStarted/GetStarted.scss';
// eslint-disable-next-line import/order
import { ASSETS_BUCKET_URL } from '@/config';

export const SelectCafeteria = () => {
  const isMobile = useMediaQuery('(max-width: 768px)', true);
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const redirectCart = () => {
    if (searchParams.get('redirect') === 'cart') return true;
    return false;
  };
  return (
    <>
      <TopBar title="Select Cafeteria" />
      <DefaultContainer>
        <Flex
          direction={{ base: 'column', sm: 'row' }}
          justify="space-between"
          align="center"
          px={{ base: 'sm', sm: 'lg' }}
          className="wrapper"
          style={{
            zIndex: 999,
            height: 'calc(100vh - 70px)',
            overflowY: isMobile ? 'auto' : 'hidden',
          }}
        >
          <div className="select-cafeteria-img">
            {isMobile ? (
              <img
                src={`${ASSETS_BUCKET_URL}/svg/SelectCafeteriaMobile.svg`}
                alt="SelectCafeteriaMobile"
                loading="lazy"
              />
            ) : (
              <img
                src={`${ASSETS_BUCKET_URL}/svg/SelectCafeteria.svg`}
                alt="SelectCafeteria"
                loading="lazy"
              />
            )}
          </div>
          <div className="select-cafeteria-content">
            <SelectCafeteriaForm
              onSuccess={(redirectURL?: string) => {
                if (redirectURL) {
                  navigate(redirectURL);
                } else if (pathname === '/auth/select-cafeteria') {
                  navigate('/auth/signup');
                } else if (pathname === '/select-cafeteria') {
                  navigate('/');
                }
              }}
              redirectCart={redirectCart()}
            />
          </div>
        </Flex>
      </DefaultContainer>
    </>
  );
};
